import BranchCard from '@/components/branch-card';
import ImageOptimizer from '@/components/image-optimizer';
import { cn } from '@/lib/utils';
import { StoreEntity } from '@/services/types/store.type';

interface Props {
  branches: StoreEntity[];
  className?: string;
}

const NearestBranches = ({ branches, className }: Props) => {
  return (
    <div
      className={cn(
        'desktop:web-w desktop:mx-auto desktop:mb-20 desktop:pb-5 mx-auto',
        className,
      )}
    >
      {/* 섹션 제목 */}
      <div className="desktop:justify-start desktop:mb-9 mb-7 flex items-center justify-center">
        <div className="relative inline-block">
          {/* 제목 */}
          <div className="desktop:block relative hidden">
            <h2 className="typo-28 text-level-2 text-center font-black">
              가장 가까운 지점을 찾아보세요!
            </h2>

            {/* hot 말풍선: 제목의 바로 뒤, 위쪽 살짝 */}
            <ImageOptimizer
              src="/images/icons/hot_bubble_2.svg"
              alt="Hot"
              width={43}
              height={26}
              className="absolute -top-[23px] -right-[27px]"
            />
          </div>
          <div className="desktop:hidden relative">
            <h2 className="typo-28 text-level-2 text-center leading-tight font-black">
              가장 가까운 지점을
              <br />
              찾아보세요!
            </h2>
            <ImageOptimizer
              src="/images/icons/icon_hot.svg"
              alt="Hot"
              width={72}
              height={36}
              className="absolute -top-[48px] left-[50%] -translate-x-1/2"
            />
          </div>
        </div>
      </div>
      {/* 3열 그리드 */}
      <div className="desktop:grid-cols-3 grid grid-cols-1 gap-8">
        {branches.map((branch) => {
          return <BranchCard {...branch} key={branch.id} />;
        })}
      </div>
    </div>
  );
};

export default NearestBranches;
